import '../scss/style.scss';
import Swiper from 'swiper';
import {
  Navigation,
  Pagination,
  Controller,
  EffectFade,
  Autoplay,
  Scrollbar,
  Mousewheel,
  Thumbs,
} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.esm.js';
import Sticky from 'sticky-js';
import L from 'leaflet';
import AOS from 'aos';
import 'aos/dist/aos.css';

// 🟢 Coloca este bloque justo después de los imports
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: new URL(
    'leaflet/dist/images/marker-icon-2x.png',
    import.meta.url
  ).href,
  iconUrl: new URL('leaflet/dist/images/marker-icon.png', import.meta.url).href,
  shadowUrl: new URL('leaflet/dist/images/marker-shadow.png', import.meta.url)
    .href,
});

document.addEventListener('DOMContentLoaded', () => {
  AOS.init();
  // nuevo slider codigo
  document.querySelectorAll('.parent-tabs').forEach((parent) => {
    const tabLinks = parent.querySelectorAll('.links-tabs a');
    const tabContents = parent.querySelectorAll('.content-tabs-general');

    function updateUnderline(sliderSection) {
      const activeItem = sliderSection.querySelector(
        '.navigations-slider.current'
      );
      const underline = sliderSection.querySelector('.underline');

      if (activeItem && underline) {
        underline.style.left = `${activeItem.offsetLeft}px`;
        underline.style.width = `${activeItem.offsetWidth}px`;
      }
    }

    tabLinks.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();

        tabLinks.forEach((link) => link.classList.remove('current'));
        tab.classList.add('current');

        tabContents.forEach((section) => {
          const contents = section.querySelectorAll('.content');
          contents.forEach((content, i) => {
            const isActive = i === index;
            content.classList.toggle('hidden', !isActive);
            if (isActive) {
              const slider = content.querySelector('.general-slider-current');
              if (slider) updateUnderline(slider);

              const video = content.querySelector('video');
              if (video) {
                video
                  .play()
                  .catch((err) => console.log('Error playing video:', err));
              }
            } else {
              const video = content.querySelector('video');

              if (video) {
                video.pause();
              }
            }
          });
        });
      });
    });

    const sliders = parent.querySelectorAll('.general-slider-current');

    sliders.forEach((sliderSection, groupIndex) => {
      const thumbs = sliderSection.querySelectorAll('.navigations-slider img');
      const title = sliderSection.querySelector('h2');
      let isTransitioning = false;

      updateUnderline(sliderSection);

      thumbs.forEach((thumb, i) => {
        const parentSlider = sliderSection;
        const titleElement = parentSlider.querySelector('.change-title');

        thumb.addEventListener('click', () => {
          if (isTransitioning) return;

          sliderSection
            .querySelectorAll('.navigations-slider')
            .forEach((li) => li.classList.remove('current'));
          thumb.closest('.navigations-slider').classList.add('current');

          const newTitle = thumb.dataset.title;
          const newSrc = thumb.dataset.image;
          if (title) title.textContent = newTitle;

          updateUnderline(sliderSection);

          const content = parent.querySelectorAll('.content')[groupIndex];
          const imageSection = content.querySelector(
            '.change-slider-tab-image'
          );
          const imageWrapper = imageSection?.querySelector('.main-image');
          const bgImage = imageSection.querySelector('.background-image');
          const parentBg = imageSection.querySelector('.parent-background');

          const isNoTransition =
            imageSection.classList.contains('no-transition');

          if (bgImage && parentBg && imageWrapper && !isNoTransition) {
            isTransitioning = true;

            let contentWidth = content.offsetWidth;
            if (!contentWidth || contentWidth === 0) {
              const prevDisplay = content.style.display;
              content.style.display = 'block';
              contentWidth = content.offsetWidth;
              content.style.display = prevDisplay;
            }

            const currentImageSrc = imageWrapper.src;
            if (currentImageSrc) {
              bgImage.style.backgroundImage = `url(${currentImageSrc})`;
              bgImage.style.backgroundSize = 'cover';
              bgImage.style.backgroundPosition = 'center';
              bgImage.style.width = `${contentWidth}px`;
            }

            imageWrapper.src = newSrc;
            imageWrapper.alt = newTitle;
            imageWrapper.title = newTitle;

            parentBg.style.transition = 'none';
            parentBg.style.width = `${contentWidth}px`;
            parentBg.style.display = 'block';
            parentBg.style.overflow = 'hidden';
            parentBg.offsetHeight;

            parentBg.style.transition = 'width 1s ease-in-out';
            parentBg.style.width = '0px';

            const transitionEndHandler = function (e) {
              if (e.propertyName === 'width') {
                parentBg.style.transition = 'none';
                parentBg.style.width = '0px';
                parentBg.style.display = 'none';
                bgImage.style.backgroundImage = '';
                isTransitioning = false;
                parentBg.removeEventListener(
                  'transitionend',
                  transitionEndHandler
                );
              }
            };

            parentBg.addEventListener('transitionend', transitionEndHandler);
          } else if (imageWrapper) {
            isTransitioning = true;

            if (isNoTransition) {
              imageWrapper.src = newSrc;
              imageWrapper.alt = newTitle;
              imageWrapper.title = newTitle;
              isTransitioning = false;
            } else {
              const newImage = document.createElement('img');
              newImage.src = newSrc;
              newImage.alt = newTitle;
              newImage.title = newTitle;
              newImage.className = imageWrapper.className;
              newImage.style.opacity = 0;
              newImage.style.transition = 'opacity 0.6s ease';
              newImage.style.position = 'absolute';
              newImage.style.inset = '0';

              newImage.onload = () => {
                imageSection.appendChild(newImage);
                void newImage.offsetWidth;

                newImage.style.opacity = 1;
                imageWrapper.style.opacity = 0;

                setTimeout(() => {
                  imageWrapper.remove();
                  newImage.style.transition = '';
                  isTransitioning = false;
                }, 600);
              };
            }
          }
        });

        thumb.addEventListener('mouseenter', () => {
          const hoverTitle = thumb.dataset.title;
          if (titleElement && hoverTitle) {
            titleElement.textContent = hoverTitle;
          }
        });

        thumb.addEventListener('mouseleave', () => {
          const activeThumb = parentSlider.querySelector(
            '.navigations-slider.current img'
          );
          const currentTitle = activeThumb ? activeThumb.dataset.title : '';
          if (titleElement && currentTitle) {
            titleElement.textContent = currentTitle;
          }
        });
      });
    });

    window.addEventListener('load', () => {
      parent
        .querySelectorAll('.general-slider-current')
        .forEach(updateUnderline);
    });
  });

  document.querySelectorAll('.parent-tabs-only').forEach((parent) => {
    function updateUnderlineOnly(sliderSection) {
      const activeItem = sliderSection.querySelector(
        '.navigations-slider-only.current-only'
      );
      const underline = sliderSection.querySelector('.underline-only');

      if (activeItem && underline) {
        underline.style.left = `${activeItem.offsetLeft}px`;
        underline.style.width = `${activeItem.offsetWidth}px`;
      }
    }

    const sliders = parent.querySelectorAll('.general-slider-current-only');

    sliders.forEach((sliderSection) => {
      const thumbs = sliderSection.querySelectorAll(
        '.navigations-slider-only img'
      );
      const title = sliderSection.querySelector('h2');
      let isTransitioning = false;
      let autoplayInterval = null;
      let currentIndex = 0;

      updateUnderlineOnly(sliderSection);

      function changeToSlide(index) {
        if (isTransitioning || !thumbs[index]) return;

        const thumb = thumbs[index];
        thumb.click();
      }

      function nextSlide() {
        currentIndex = (currentIndex + 1) % thumbs.length;
        changeToSlide(currentIndex);
      }

      const autoplaySection = parent.closest('.fci-autoplay-section');
      if (autoplaySection) {
        autoplayInterval = setInterval(nextSlide, 5000);

        parent.addEventListener('mouseenter', () => {
          if (autoplayInterval) {
            clearInterval(autoplayInterval);
          }
        });

        parent.addEventListener('mouseleave', () => {
          if (autoplayInterval) {
            clearInterval(autoplayInterval);
          }
          autoplayInterval = setInterval(nextSlide, 5000);
        });
      }

      thumbs.forEach((thumb, index) => {
        const parentSlider = sliderSection;
        const titleElement = parentSlider.querySelector('.change-title-only');

        thumb.addEventListener('click', () => {
          if (isTransitioning) return;

          currentIndex = index;

          if (autoplayInterval) {
            clearInterval(autoplayInterval);
            autoplayInterval = setInterval(nextSlide, 5000);
          }

          sliderSection
            .querySelectorAll('.navigations-slider-only')
            .forEach((li) => li.classList.remove('current-only'));
          thumb
            .closest('.navigations-slider-only')
            .classList.add('current-only');

          const newTitle = thumb.dataset.title;
          const newSrc = thumb.dataset.image;
          if (title) title.textContent = newTitle;

          updateUnderlineOnly(sliderSection);

          const contentOnly = parent.querySelector('.content-only');
          const imageSection = contentOnly.querySelector(
            '.change-slider-tab-image-only'
          );
          const imageWrapper = imageSection?.querySelector('.main-image');
          const bgImage = imageSection.querySelector('.background-image');
          const parentBg = imageSection.querySelector('.parent-background');

          if (bgImage && parentBg && imageWrapper) {
            isTransitioning = true;

            let contentWidth = contentOnly.offsetWidth;
            if (!contentWidth || contentWidth === 0) {
              const prevDisplay = contentOnly.style.display;
              contentOnly.style.display = 'block';
              contentWidth = contentOnly.offsetWidth;
              contentOnly.style.display = prevDisplay;
            }

            const currentImageSrc = imageWrapper.src;
            if (currentImageSrc) {
              bgImage.style.backgroundImage = `url(${currentImageSrc})`;
              bgImage.style.backgroundSize = 'cover';
              bgImage.style.backgroundPosition = 'center';
              bgImage.style.width = `${contentWidth}px`;
            }

            imageWrapper.src = newSrc;
            imageWrapper.alt = newTitle;
            imageWrapper.title = newTitle;

            parentBg.style.transition = 'none';
            parentBg.style.width = `${contentWidth}px`;
            parentBg.style.display = 'block';
            parentBg.style.overflow = 'hidden';
            parentBg.offsetHeight;

            parentBg.style.transition = 'width 1s ease-in-out';
            parentBg.style.width = '0px';

            const transitionEndHandler = function (e) {
              if (e.propertyName === 'width') {
                parentBg.style.transition = 'none';
                parentBg.style.width = '0px';
                parentBg.style.display = 'none';
                bgImage.style.backgroundImage = '';
                isTransitioning = false;
                parentBg.removeEventListener(
                  'transitionend',
                  transitionEndHandler
                );
              }
            };

            parentBg.addEventListener('transitionend', transitionEndHandler);
          }
        });

        thumb.addEventListener('mouseenter', () => {
          const hoverTitle = thumb.dataset.title;
          if (titleElement && hoverTitle) {
            titleElement.textContent = hoverTitle;
          }
        });

        thumb.addEventListener('mouseleave', () => {
          const activeThumb = parentSlider.querySelector(
            '.navigations-slider-only.current-only img'
          );
          const currentTitle = activeThumb ? activeThumb.dataset.title : '';
          if (titleElement && currentTitle) {
            titleElement.textContent = currentTitle;
          }
        });
      });
    });

    window.addEventListener('load', () => {
      parent
        .querySelectorAll('.general-slider-current-only')
        .forEach(updateUnderlineOnly);
    });
  });

  //js search
  const navSearch = document.querySelector('.nav-search .search-trigger');
  const closeSearch = document.querySelector('.close-search');
  const modalSearch = document.querySelector('.modal-search');
  const modalInput = modalSearch.querySelector('input');
  const openMobile = document.querySelector('.open-mobile');
  const closeMobile = document.querySelector('.close-mobile');
  const navMain = document.querySelector('.nav-main');

  if (navSearch && modalSearch) {
    navSearch.addEventListener('click', (e) => {
      e.preventDefault();

      modalSearch.classList.remove('hidden');
      modalSearch.classList.add('flex');

      requestAnimationFrame(() => {
        modalInput.focus();
      });
    });
  }

  if (closeSearch && modalSearch) {
    closeSearch.addEventListener('click', (e) => {
      e.preventDefault();

      modalSearch.classList.add('hidden');
      modalSearch.classList.remove('flex');
    });
  }

  openMobile.addEventListener('click', (e) => {
    e.preventDefault();

    navMain.classList.remove('max-[960px]:hidden');
    setTimeout(() => {
      navMain.classList.add('active');
    }, 100);
  });

  closeMobile.addEventListener('click', (e) => {
    e.preventDefault();

    navMain.classList.remove('active');
    setTimeout(() => {
      navMain.classList.add('max-[960px]:hidden');
    }, 600);
  });

  //Acordeon footer
  if (window.innerWidth < 960) {
    const titles = document.querySelectorAll('.title-foo');

    titles.forEach((title) => {
      const arrow = title.querySelector('.arrow-acor');
      const content = title.nextElementSibling;

      if (!arrow || !content) return;

      content.style.overflow = 'hidden';
      content.style.transition = 'max-height 0.4s ease';
      content.style.maxHeight = '0px';

      arrow.style.transition = 'transform 0.3s ease';

      title.addEventListener('click', function () {
        const isOpen = content.style.maxHeight !== '0px';

        document.querySelectorAll('.content-foo').forEach((el) => {
          el.style.maxHeight = '0px';
          el.previousElementSibling.querySelector(
            '.arrow-acor'
          ).style.transform = 'rotate(0deg)';
        });

        if (isOpen) {
          content.style.maxHeight = '0px';
          arrow.style.transform = 'rotate(0deg)';
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          arrow.style.transform = 'rotate(180deg)';
        }
      });
    });
  }

  Fancybox.bind('[data-fancybox]');

  let sticky;
  if (window.innerWidth > 960) {
    sticky = new Sticky('.fixed-element');
  }

  // Inicializar mapas Leaflet
  if (document.querySelector('.map')) {
    document.querySelectorAll('.map').forEach((el) => {
      try {
        const config = JSON.parse(el.dataset.map);
        if (!config || !config.tiendas || !config.tiendas.length) return;

        const map = L.map(el);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors',
        }).addTo(map);

        const bounds = L.latLngBounds([]);

        config.tiendas.forEach((item) => {
          const lat = parseFloat(item.tienda.latitud);
          const lng = parseFloat(item.tienda.longitud);
          if (!isNaN(lat) && !isNaN(lng)) {
            L.marker([lat, lng])
              .addTo(map)
              .bindPopup(`<strong>${item.tienda.nombre}</strong>`);
            bounds.extend([lat, lng]);
          }
        });

        if (bounds.isValid()) {
          map.fitBounds(bounds, { padding: [30, 30], maxZoom: 13 });
        } else if (config.region) {
          map.setView([config.region.latitud, config.region.longitud], 13);
        }
      } catch (e) {
        console.error('Error al inicializar el mapa:', e);
      }
    });
  }

  // current nav
  const menus = document.querySelectorAll('.menu');

  menus.forEach((menu) => {
    const items = menu.querySelectorAll('li.navigations');
    const underline = menu.querySelector('.underline');

    function moveUnderline(target) {
      const { offsetLeft, offsetWidth } = target;
      underline.style.width = `${offsetWidth}px`;
      underline.style.transform = `translateX(${offsetLeft}px)`;
    }

    const currentItem = menu.querySelector('.current');
    if (currentItem) {
      moveUnderline(currentItem);
    }

    items.forEach((item) => {
      item.addEventListener('mouseenter', () => moveUnderline(item));
      item.addEventListener('mouseleave', () => {
        if (currentItem) moveUnderline(currentItem);
      });

      item.addEventListener('click', () => {
        menu
          .querySelectorAll('.current')
          .forEach((el) => el.classList.remove('current'));
        item.classList.add('current');
        moveUnderline(item);
      });
    });
  });

  // slider tabs
  const tabs_slider = new Swiper('.slider-tabs', {
    modules: [Navigation],
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next-tabs',
      prevEl: '.swiper-button-prev-tabs',
    },
  });

  const columns_cars_slider = new Swiper('.columns-cars-slider', {
    modules: [Navigation, Pagination],
    slidesPerView: 4,
    spaceBetween: 58,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next-cars',
      prevEl: '.swiper-button-prev-cars',
    },
    pagination: {
      el: '.columns-cars-slider-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      680: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      960: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 58,
      },
    },
  });

  document.querySelectorAll('.slider-view2').forEach((sliderEl) => {
    const parent = sliderEl.closest('.columns-slider-view2-wrapper');

    const sliderClasses = sliderEl.className.split(' ');
    const blockIdClass = sliderClasses.find((cls) =>
      cls.startsWith('slider-view2-block_')
    );
    const blockId = blockIdClass
      ? blockIdClass.replace('slider-view2-', '')
      : '';

    if (!blockId) {
      console.warn('Block ID not found for slider-view2', sliderEl);
      return;
    }

    const nextEl = parent.querySelector(`.swiper-button-next-view2-${blockId}`);
    const prevEl = parent.querySelector(`.swiper-button-prev-view2-${blockId}`);
    const paginationEl = parent.querySelector(
      `.slider-view2-pagination-${blockId}`
    );

    new Swiper(sliderEl, {
      modules: [Navigation, Pagination],
      slidesPerView: 2,
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        680: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        960: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
      },
    });
  });

  const slider_color_view2 = new Swiper('.slider-color-view2', {
    modules: [Navigation, Pagination],
    slidesPerView: 2,
    spaceBetween: 10,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next-color-view2',
      prevEl: '.swiper-button-prev-color-view2',
    },
    pagination: {
      el: '.slider-color-view2-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      680: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      960: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
    },
  });

  const slider_view3 = new Swiper('.slider-view3', {
    modules: [Navigation, Pagination],
    slidesPerView: 3,
    spaceBetween: 10,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next-view3',
      prevEl: '.swiper-button-prev-view3',
    },
    pagination: {
      el: '.slider-view3-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      680: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      960: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
    },
  });

  const banner_middle_slider = new Swiper('.banner-middle-slider', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next-banner',
      prevEl: '.swiper-button-prev-banner',
    },
    pagination: {
      el: '.banner-middle-slider-pagination',
      clickable: true,
    },
  });

  // Show fixed menu on scroll
  if (document.querySelector('.show-on-scroll')) {
    const target = document.querySelector('.show-on-scroll');
    const showAtPercentage = 8;

    function toggleVisibilityOnScroll() {
      const scrollTop = window.scrollY;
      const windowHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / windowHeight) * 100;

      if (scrollPercent >= showAtPercentage) {
        target.classList.add('active');
      } else {
        target.classList.remove('active');
      }
    }

    window.addEventListener('scroll', toggleVisibilityOnScroll);
  }

  // Fixed element styles on scroll
  if (document.querySelector('.fixed-element')) {
    const fixed = document.querySelector('.fixed-element');
    const toggleAt = 1;

    function changeFixedElementStyles() {
      const scrollTop = window.scrollY;
      const windowHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / windowHeight) * 100;

      if (scrollPercent >= toggleAt) {
        fixed.classList.add('toggle');
      } else {
        fixed.classList.remove('toggle');
      }
    }

    window.addEventListener('scroll', changeFixedElementStyles);
  }

  // Acordeon
  const items = document.querySelectorAll('.accordion-item');

  items.forEach((item) => {
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.accordion-content');
    const icon = item.querySelector('.accordion-icon');

    header.addEventListener('click', () => {
      const isOpen =
        content.style.maxHeight && content.style.maxHeight !== '0px';

      items.forEach((i) => {
        i.querySelector('.accordion-content').style.maxHeight = null;
        i.querySelector('.accordion-icon').classList.remove('rotate-180');
        i.querySelector('.accordion-header').classList.remove('active');
      });

      if (!isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.classList.add('rotate-180');
        header.classList.add('active');
      }
    });
  });

  document.querySelectorAll('.main-slider').forEach((sliderEl) => {
    const parent = sliderEl.closest('.relative');
    const progressBar = parent.querySelector('.progress-bar');
    const prevEl = parent.querySelector('.swiper-button-prev');
    const nextEl = parent.querySelector('.swiper-button-next');

    let state = {
      progress: 0,
      duration: 6000,
      startTime: null,
      rafId: null,
    };

    const swiper = new Swiper(sliderEl, {
      modules: [Navigation],
      speed: 1000,
      loop: true,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      on: {
        init() {
          state.startTime = performance.now();
          updateProgress();
        },
        slideChange() {
          state.progress = 0;
          state.startTime = performance.now();
          progressBar.style.width = '0%';

          sliderEl.querySelectorAll('.slide-image').forEach((img) => {
            img.style.transform = 'scale(1)';
          });
        },
      },
    });

    function updateProgress(now) {
      if (!state.startTime) state.startTime = now;
      const elapsed = now - state.startTime;
      state.progress = Math.min((elapsed / state.duration) * 100, 100);

      progressBar.style.width = `${state.progress}%`;

      const activeSlide = sliderEl.querySelector('.swiper-slide-active');
      if (activeSlide) {
        const activeImage = activeSlide.querySelector('.slide-image');
        if (activeImage) {
          const scale = 1 + (state.progress / 100) * 0.1;
          activeImage.style.transform = `scale(${scale})`;
          activeImage.style.transition = 'transform 0.1s linear';
        }
      }

      if (state.progress >= 100) {
        cancelAnimationFrame(state.rafId);
        setTimeout(() => {
          swiper.slideNext();
          state.progress = 0;
          state.startTime = performance.now();
          state.rafId = requestAnimationFrame(updateProgress);
        }, 1000);
        return;
      }

      state.rafId = requestAnimationFrame(updateProgress);
    }

    parent.addEventListener('mouseenter', () => {
      //cancelAnimationFrame(state.rafId);
    });

    parent.addEventListener('mouseleave', () => {
      state.startTime =
        performance.now() - (state.progress / 100) * state.duration;
      state.rafId = requestAnimationFrame(updateProgress);
    });
  });

  // video play
  document.querySelectorAll('.play-wrapper').forEach((wrapper) => {
    const video = wrapper.parentElement.querySelector('video');

    if (video) {
      wrapper.addEventListener('click', () => {
        wrapper.classList.add('hidden');
        video.play();
      });
    }
  });

  document.querySelectorAll('.video-section').forEach((section) => {
    const muteToggle = section.querySelector('.mute-toggle');
    const video = section.querySelector('.video-element');
    const volumeIcon = section.querySelector('.volume-icon');

    if (muteToggle && video && volumeIcon) {
      muteToggle.addEventListener('click', () => {
        if (video.muted) {
          video.muted = false;
          volumeIcon.textContent = 'volume_up';
        } else {
          video.muted = true;
          volumeIcon.textContent = 'volume_off';
        }
      });
    }
  });

  // tabs js
  document.querySelectorAll('.parent-tabs').forEach((parent) => {
    const tabLinks = parent.querySelectorAll('.links-tabs a');
    const contentGroups = parent.querySelectorAll('.content-tabs-general');

    tabLinks.forEach((link, index) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        tabLinks.forEach((l) => l.classList.remove('current'));
        this.classList.add('current');

        contentGroups.forEach((group) => {
          const contents = group.querySelectorAll('.content');
          contents.forEach((content, i) => {
            const isVisible = i === index;
            content.classList.toggle('hidden', !isVisible);

            if (!isVisible) {
              content.querySelectorAll('video').forEach((video) => {
                video.pause();
                video.currentTime = 0;

                const playWrapper = content.querySelector('.play-wrapper');
                if (playWrapper) {
                  playWrapper.classList.remove('hidden');
                }
              });
            }
          });
        });
      });
    });
  });

  // show filters
  const toggleBtn = document.querySelectorAll('.see-filter');
  const closeModalfilter = document.querySelector('.close-mobile-filter');
  const wrapper = document.querySelector('.wrapper-expand');
  const navigation = document.querySelector('.expand-navigation');

  if (toggleBtn && wrapper && navigation) {
    toggleBtn.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        wrapper.classList.toggle('expand');
        navigation.classList.toggle('show-nav');

        const iconOpen = btn.querySelector('.icon-open');
        const iconClose = btn.querySelector('.icon-close');
        const filterText = btn.querySelector('.filter-text');

        if (iconOpen && iconClose) {
          iconOpen.classList.toggle('hidden');
          iconClose.classList.toggle('hidden');
        }

        if (filterText) {
          if (filterText.textContent.trim() === 'Ver filtros') {
            filterText.textContent = 'Ocultar filtros';
          } else {
            filterText.textContent = 'Ver filtros';
          }
        }
      });
    });

    closeModalfilter.addEventListener('click', (e) => {
      e.preventDefault();
      wrapper.classList.remove('expand');
    });
  }

  // filters acor
  const filtersA = document.querySelectorAll('.filters-item');

  filtersA.forEach((items) => {
    const headerA = items.querySelector('.filter-title');
    const contentA = items.querySelector('.content-filter');
    const iconA = items.querySelector('.filter-icon');

    headerA.addEventListener('click', () => {
      const isOpen =
        contentA.style.maxHeight && contentA.style.maxHeight !== '0px';

      filtersA.forEach((i) => {
        i.querySelector('.content-filter').style.maxHeight = null;
        i.querySelector('.filter-icon').classList.remove('rotate-90', 'move-r');
        i.querySelector('.filter-title').classList.remove('active');
      });

      if (!isOpen) {
        contentA.style.maxHeight = contentA.scrollHeight + 'px';
        iconA.classList.add('rotate-90', 'move-r');
        headerA.classList.add('active');
      }
    });
  });

  // selects
  const selects = document.querySelectorAll('[data-select]');

  selects.forEach((select) => {
    const toggleBtn = select.querySelector('[data-toggle]');
    const menu = select.querySelector('[data-menu]');
    const label = select.querySelector('[data-label]');
    const icon = select.querySelector('[data-icon]');

    const price = select.querySelector('[data-price]'); // Hidden input con el valor seleccionado

    const contentFilter = select.closest('.content-filter');

    toggleBtn.addEventListener('click', (e) => {
      e.stopPropagation();

      const isHidden = menu.classList.contains('hidden');

      document.querySelectorAll('[data-select]').forEach((otherSelect) => {
        const otherMenu = otherSelect.querySelector('[data-menu]');
        const otherIcon = otherSelect.querySelector('[data-icon]');
        if (otherMenu !== menu) {
          otherMenu.classList.add('hidden');
          otherIcon.classList.remove('rotate-180');
          const otherFilter = otherSelect.closest('.content-filter');
          if (otherFilter) otherFilter.classList.add('overflow-hidden');
        }
      });

      menu.classList.toggle('hidden', !isHidden);
      icon.classList.toggle('rotate-180', isHidden);

      if (contentFilter) {
        contentFilter.classList.toggle('overflow-hidden', !isHidden);
      }
    });

    menu.querySelectorAll('li').forEach((option) => {
      option.addEventListener('click', () => {
        label.textContent = option.dataset.value;
        price.value = option.dataset.value;
        price.dispatchEvent(new Event('change')); // Para enviar el submit del form

        menu.classList.add('hidden');
        icon.classList.remove('rotate-180');

        if (contentFilter) {
          contentFilter.classList.add('overflow-hidden');
        }
      });
    });
  });

  document.addEventListener('click', () => {
    document.querySelectorAll('[data-select]').forEach((select) => {
      const menu = select.querySelector('[data-menu]');
      const icon = select.querySelector('[data-icon]');
      const contentFilter = select.closest('.content-filter');

      menu.classList.add('hidden');
      icon.classList.remove('rotate-180');

      if (contentFilter) {
        contentFilter.classList.add('overflow-hidden');
      }
    });
  });

  function updateLinks() {
    const links = document.querySelectorAll('.dynamic-link');
    links.forEach((link) => {
      const isMobile = window.innerWidth <= 768;
      link.href = isMobile ? link.dataset.mobile : link.dataset.desktop;
    });
  }

  updateLinks();
  window.addEventListener('resize', updateLinks);

  if (document.querySelector('.mega-menu')) {
    document.querySelectorAll('.mega-menu').forEach((menuItem) => {
      const html = document.querySelector('html');
      const header = document.querySelector('header');
      const trigger = menuItem.querySelector('a');
      const megaMenuContent = menuItem.querySelector('.mega-menu-content');
      const megaMenuBg = menuItem.querySelector('.mega-menu-bg');
      const mainLogo = document.querySelector('.logo-main');
      const altLogo = document.querySelector('.logo-white');
      const backMobile = document.querySelector('.back-mobile');
      const megaMenuItems = menuItem.querySelectorAll('.mega-menu-item');

      if (!trigger || !megaMenuContent || !megaMenuBg) return;

      trigger.addEventListener('click', (e) => {
        e.preventDefault();

        const isActive = megaMenuContent.classList.contains('active');

        document
          .querySelectorAll('.mega-menu-content.active, .mega-menu-bg.active')
          .forEach((el) => {
            el.classList.remove('active');
          });
        html.classList.remove('scroll-none');
        if (window.scrollY == 0 || header.classList.contains('toggle'))
          header.classList.remove('active');
        mainLogo.classList.remove('opacity-0');
        altLogo.classList.remove('opacity-100');

        if (!isActive) {
          html.classList.add('scroll-none');
          header.classList.add('active');
          megaMenuContent.classList.add('active');
          megaMenuBg.classList.add('active');
          mainLogo.classList.add('opacity-0', 'delay-100');
          altLogo.classList.add('opacity-100', 'delay-100');
          megaMenuItems.forEach((el) => {
            el.classList.add('active');
          });
        } else {
          mainLogo.classList.remove('opacity-0', 'delay-100');
          altLogo.classList.remove('opacity-100', 'delay-100');
          megaMenuItems.forEach((el) => {
            el.classList.remove('active');
          });
        }
      });

      megaMenuBg.addEventListener('click', () => {
        html.classList.remove('scroll-none');
        header.classList.remove('active');
        megaMenuContent.classList.remove('active');
        megaMenuBg.classList.remove('active');
        mainLogo.classList.remove('opacity-0', 'delay-100');
        altLogo.classList.remove('opacity-100', 'delay-100');
        megaMenuItems.forEach((el) => {
          el.classList.remove('active');
        });
      });

      backMobile.addEventListener('click', (e) => {
        e.preventDefault();
        html.classList.remove('scroll-none');
        header.classList.remove('active');
        megaMenuContent.classList.remove('active');
        megaMenuBg.classList.remove('active');
        mainLogo.classList.remove('opacity-0', 'delay-100');
        altLogo.classList.remove('opacity-100', 'delay-100');
      });
    });
  }

  // Formulario Filtro de Modelos en la taxonomia.
  if (
    document.querySelector('#model-form-filter') &&
    document.querySelector('#models-container')
  ) {
    const form = document.querySelector('#model-form-filter');
    const loader = document.querySelector('#loading-spinner');

    // Cada que cambia un valor en los campos del filtro, se manda la petición Ajax
    form.querySelectorAll('input').forEach((item) => {
      item.addEventListener('change', () => {
        const formData = new FormData(form);
        document.querySelector('#models-container').innerHTML = '';

        // Mostrar loader
        loader.classList.remove('hidden');

        fetch(form.getAttribute('action'), {
          method: form.getAttribute('method'),
          body: formData,
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Error en la respuesta de la red');
            }
            return response.text();
          })
          .then((response) => {
            document.querySelector('#models-container').innerHTML = response;
            //console.log('Respuesta recibida:', data);
          })
          .catch((error) => {
            console.error('Hubo un error en el envío del formulario:', error);
          })
          .finally(() => {
            // Ocultar loader
            loader.classList.add('hidden');
          });
      });
    });
  }

  // Cotizador
  if (document.querySelector('.step')) {
    window.currentStep = 0;

    window.getSteps = () => document.querySelectorAll('.step');
    window.getStep = (index) => getSteps()[index ?? currentStep] ?? null;

    function getUrlSearchParams() {
      return new URLSearchParams(window.location.search);
    }

    function escapeSelector(value) {
      if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
        return CSS.escape(value);
      }
      return String(value).replace(/(["\\])/g, "\\$1");
    }

    function findRadioByValueOrName(selector, value) {
      if (!value) return null;
      const escaped = escapeSelector(value);
      try {
        return (
          document.querySelector(selector + `[value="${escaped}"]`) ||
          document.querySelector(selector + `[data-name="${escaped}"]`)
        );
      } catch (e) {
        const candidates = document.querySelectorAll(selector);
        for (const candidate of Array.from(candidates)) {
          if (candidate.value === value || candidate.dataset?.name === value) {
            return candidate;
          }
        }
        return null;
      }
    }

    const urlState = {
      serie: null,
      model: null,
      version: null,
      step: null,
    };

    function updateTrackingUrl() {
      const params = getUrlSearchParams();
      params.set('step', String(currentStep + 1));

      const selectedSerie = document.querySelector(
        'input[type="radio"].serie:checked'
      );
      if (selectedSerie?.dataset.name) {
        params.set('serie', selectedSerie.dataset.name);
      } else if (selectedSerie?.value) {
        params.set('serie', selectedSerie.value);
      } else {
        params.delete('serie');
      }

      const selectedModel = document.querySelector(
        '.models input[type="radio"][name="model"]:checked'
      ) || document.querySelector('input[type="radio"][name="model"]:checked');
      if (selectedModel?.dataset.name) {
        params.set('model', selectedModel.dataset.name);
      } else if (selectedModel?.value) {
        params.set('model', selectedModel.value);
      } else {
        params.delete('model');
      }

      const selectedVersion = document.querySelector(
        '#versions-container input[type="radio"][name="version"]:checked'
      ) || document.querySelector('input[type="radio"][name="version"]:checked');
      if (selectedVersion?.dataset.name) {
        params.set('version', selectedVersion.dataset.name);
      } else if (selectedVersion?.value) {
        params.set('version', selectedVersion.value);
      } else {
        params.delete('version');
      }

      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, '', newUrl);
    }

    function initializeStateFromUrl() {
      const params = getUrlSearchParams();

      urlState.serie = params.get('serie');
      urlState.model = params.get('model');
      urlState.version = params.get('version');

      const urlStep = parseInt(params.get('step'), 10);
      if (!Number.isNaN(urlStep) && urlStep >= 1 && urlStep <= getSteps().length) {
        urlState.step = urlStep;
      }
    }

    function setStepFromUrl() {
      if (urlState.step) {
        currentStep = Math.min(urlState.step - 1, getSteps().length - 1);
      }
    }

    function loadVersionsForModel(modelInput, versionName) {
      if (!modelInput) return Promise.resolve();
      showLoader();

      const postId = document.querySelector('#post_id')?.value || '';
      const modelId = modelInput.value || modelInput;
      const ajaxUrl = (typeof app !== 'undefined' && app.ajaxUrl) || '/wp-admin/admin-ajax.php';

      const params = new URLSearchParams({
        action: 'get_model_versions',
        post_id: postId,
        model_id: modelId,
        version_id: '',
      });

      return fetch(`${ajaxUrl}?${params}`)
        .then((res) => (res.ok ? res.json() : Promise.reject('Network error')))
        .then((response) => {
          const html = response?.data?.html || '';
          const versionsContainer = document.querySelector('#versions-container');
          if (versionsContainer) versionsContainer.innerHTML = html;
          document.dispatchEvent(new CustomEvent('versionsLoaded'));

          if (typeof attachAllRadioListeners === 'function') {
            attachAllRadioListeners();
          }

          if (typeof attachModelCardListeners === 'function') {
            attachModelCardListeners();
          }

          if (versionName) {
            const versionInput = findRadioByValueOrName(
              '#versions-container input[type="radio"][name="version"]',
              versionName
            ) || findRadioByValueOrName('input[type="radio"][name="version"]', versionName);
            if (versionInput) {
              versionInput.checked = true;
              versionInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          setStepFromUrl();
          updateSteps();
        })
        .catch((err) => console.error('Error:', err))
        .finally(() => {
          if (typeof hideLoader === 'function') hideLoader();
        });
    }

    function loadModelsForSerie(serieInput, modelName, versionName) {
      if (!serieInput) return Promise.resolve();
      showLoader();

      const postId = document.querySelector('#post_id')?.value || '';
      const serieId = serieInput.value || serieInput;
      const ajaxUrl = (typeof app !== 'undefined' && app.ajaxUrl) || '/wp-admin/admin-ajax.php';

      const params = new URLSearchParams({
        action: 'quatation_models',
        post_id: postId,
        serie_id: serieId,
      });

      return fetch(`${ajaxUrl}?${params}`)
        .then((res) => (res.ok ? res.text() : Promise.reject('Network error')))
        .then((html) => {
          const modelContainer = document.querySelector('#model-step-container');
          if (modelContainer) {
            modelContainer.innerHTML = html;
          }

          document.dispatchEvent(new CustomEvent('modelsLoaded'));

          if (typeof attachAllRadioListeners === 'function') {
            attachAllRadioListeners();
          }

          if (typeof attachModelCardListeners === 'function') {
            attachModelCardListeners();
          }

          if (modelName) {
            const modelInput = findRadioByValueOrName(
              '#model-step-container input[type="radio"][name="model"]',
              modelName
            ) || findRadioByValueOrName('.models input[type="radio"][name="model"]', modelName);
            if (modelInput) {
              modelInput.checked = true;
              modelInput.dispatchEvent(new Event('change', { bubbles: true }));
              data.modelId = modelInput.value;
              window.app = window.app || {};
              window.app.modelId = modelInput.value;
            }
          }

          const selectedModel = document.querySelector(
            '.models input[type="radio"][name="model"]:checked'
          );

          if (versionName && selectedModel) {
            return loadVersionsForModel(selectedModel, versionName);
          }

          setStepFromUrl();
          updateSteps();
        })
        .catch((err) => console.error('Error:', err))
        .finally(() => {
          if (typeof hideLoader === 'function') hideLoader();
        });
    }

    // Barra de control de cuota
    const controlDataBar = document.querySelector('#control-data-bar');
    const barFuelType = controlDataBar?.querySelector('#bar-fuel-type');
    const barModelName = controlDataBar?.querySelector('#bar-model-name');
    const barModelPrice = controlDataBar?.querySelector('#bar-model-price');

    const getLastStep = () => {
      const steps = getSteps();

      return steps[steps.length - 1];
    };

    const parentBack = document.querySelector('.parent-back');
    const btnBack = document.getElementById('btnBack');
    const btnNext = document.getElementById('btnNext');
    const btnBackText = btnBack.querySelector('span');
    const btnNextText = btnNext.querySelector('span');

    let data = {
      serieId: null,
      modelId: null,
    };

    function updateSteps() {
      const steps = getSteps();

      steps.forEach((step, index) => {
        step.classList.toggle('active', index === currentStep);
      });

      const current = steps[currentStep];
      const previous = steps[currentStep - 1];

      btnBack.style.display = currentStep > 0 ? 'flex' : 'none';
      parentBack.style.display = currentStep > 0 ? 'flex' : 'none';

      const nextText = current?.dataset.next || 'Siguiente';
      const backText = previous?.dataset.back || 'Atrás';

      const hideOnMobile = (text) => {
        return text.replace(
          /(Anterior|Siguiente)(\s+\/\s+)/g,
          '<span class="max-[680px]:hidden">$1$2</span>'
        );
      };

      btnNextText.innerHTML = hideOnMobile(nextText);
      btnBackText.innerHTML = hideOnMobile(backText);

      document.querySelectorAll('.fixed-car .navigations').forEach((nav, i) => {
        nav.classList.toggle('current', i === currentStep);
      });

      updateUnderline();
      validateCurrentStep();
      updateTrackingUrl();

      if (currentStep === 0) {
        if (barFuelType) barFuelType.textContent = 'N/A';
        if (barModelName) barModelName.textContent = 'N/A';
        if (barModelPrice) barModelPrice.textContent = 'N/A';
      } else if (currentStep === 5) {
        //console.log('Step 5', currentStep);
        saveStepRadioSelections();
      } else if (currentStep === 6) {
        //document.querySelector('.nav-last')?.classList.add('hidden');
        //console.log('Step 6', currentStep);
        //console.log(localStorage.getItem('multiStepRadioSelections'));
        saveStepRadioSelections();
      }
    }

    function updateUnderline() {
      const underline = document.querySelector('.fixed-car .underline');
      const currentNav = document.querySelector(
        '.fixed-car .navigations.current'
      );

      if (underline && currentNav) {
        const navRect = currentNav.getBoundingClientRect();
        const parentRect = currentNav.parentElement.getBoundingClientRect();

        underline.style.transform = `translateX(${
          navRect.left - parentRect.left
        }px)`;
        underline.style.width = `${navRect.width}px`;
      }
    }

    function validateCurrentStep() {
      const current = getStep();

      const radios = current.querySelectorAll('input[type="radio"]');
      const selected = current.querySelector('input[type="radio"]:checked');

      if (getLastStep() == current) {
        //console.log('last current');
      } else {
        btnNext.disabled = radios.length > 0 && !selected;
      }
    }

    function showLoader() {
      document.getElementById('loader-overlay')?.classList.remove('hidden');
    }

    function hideLoader() {
      document.getElementById('loader-overlay')?.classList.add('hidden');
    }

    function syncGravityFormInputsBeforeSubmit(form) {
      if (!form) return;

      const syncTargets = form.querySelectorAll(
        '.ginput_container_phone input, .gf-telephone, input[type="tel"]'
      );

      syncTargets.forEach((input) => {
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('blur', { bubbles: true }));
      });

      requestAnimationFrame(() => {
        syncTargets.forEach((input) => {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }

    function attachRadioListenersToStep(step) {
      step.querySelectorAll('input[type="radio"]').forEach((input) => {
        const changeListener = () => {
          if (getStep().contains(input)) {
            validateCurrentStep();
          }
          updateTrackingUrl();
        };

        // Eliminar cualquier listener previo antes de agregar uno nuevo
        input.removeEventListener('change', changeListener);
        input.addEventListener('change', changeListener);
      });
    }

    window.attachAllRadioListeners = function () {
      //attachRadioListenersToStep(getStep(currentStep + 1));
      getSteps().forEach(attachRadioListenersToStep);
    };

    function attachModelCardListeners() {
      document
        .querySelectorAll('.models input[type="radio"][name="model"]')
        .forEach((radio) => {
          radio.addEventListener('change', () => {
            if (radio.checked) {
              data.modelId = radio.value;
              updateTrackingUrl();

              // Mostrar todas las .car-option
              document.querySelectorAll('.car-option').forEach((option) => {
                option.classList.remove('hidden');
              });

              const modelCard =
                radio.closest('label')?.querySelector('.peer-checked') ||
                radio.closest('label')?.querySelector('div');
              const modelName = modelCard
                ?.querySelector('h3')
                ?.textContent.trim();
              const modelImageSrc = modelCard
                ?.querySelector('img')
                ?.getAttribute('src');

              // Actualizar el contenido en todas las .car-option
              document.querySelectorAll('.car-option').forEach((option) => {
                const targetName = option.querySelector('.model-name');
                const targetImage = option.querySelector('.model-image');

                if (modelName && targetName) targetName.textContent = modelName;
                if (modelImageSrc && targetImage)
                  targetImage.setAttribute('src', modelImageSrc);
              });
            }
          });
        });
    }

    // Botones
    const versionsContainer = document.querySelector('#versions-container');
    btnNext.addEventListener('click', () => {
      //console.log('step.dataset', step.dataset);
      //const current = getStep();

      // Si el paso actual tiene input.serie seleccionado y el contenedor #model-step-container está vacío
      const serieInput = document.querySelector(
        'input[type="radio"].serie:checked'
      );

      const needsModelAjax = serieInput && currentStep == 0; //&& document.querySelector('#model-step-container:empty');
      const needsVersionAjax =
        versionsContainer && serieInput && currentStep == 1;

      if (needsModelAjax) {
        showLoader();

        const postId = document.querySelector('#post_id').value;

        const serieId = serieInput.value;
        //const modelId = serieInput.dataset.model; // Este model es el que se pasa por URL

        // Traer los modelos
        const params = new URLSearchParams({
          action: 'quatation_models',
          post_id: postId,

          serie_id: serieId,
          //model_id: modelId
        });

        fetch(`${app.ajaxUrl}?${params}`)
          .then((res) =>
            res.ok ? res.text() : Promise.reject('Network error')
          )
          .then((html) => {
            document.querySelector('#model-step-container').innerHTML = html;
            document.dispatchEvent(new CustomEvent('modelsLoaded'));

            attachAllRadioListeners();
            attachModelCardListeners();

            currentStep++;
            updateSteps();

            /*if (modelId) {
                            const radio = document.querySelector(`#model-step-container #m-${modelId}`);
                            radio.click();
                        }*/

            const modelElement = document.querySelector(
              `#m-${window.app.modelId}`
            );
            if (modelElement) {
              modelElement.checked = true;
              modelElement.dispatchEvent(
                new Event('change', { bubbles: true })
              );

              const nextButton = document.querySelector('#btnNext');
              if (nextButton) {
                nextButton.click();
                delete window.app.modelId;
              }
            }
          })
          .catch((err) => console.error('Error:', err))
          .finally(hideLoader);
      } else if (needsVersionAjax) {
        const modelInput = document.querySelector(
          'input[type="radio"][name="model"]:checked'
        );
        if (!modelInput) return;

        showLoader();

        const postId = document.querySelector('#post_id').value;
        const modelId = modelInput.value; // Este model es el que se pasa por URL

        // Traer los modelos
        const params = new URLSearchParams({
          action: 'get_model_versions',
          post_id: postId,
          model_id: modelId,
          version_id: '', //Cuando se quiere cargar una versión por defecto
        });

        // Cargar las versiones
        fetch(`${app.ajaxUrl}?${params}`)
          .then((res) =>
            res.ok ? res.json() : Promise.reject('Network error')
          )
          .then((response) => {
            if (!response.success) {
              document.querySelector('#versions-container').innerHTML = '';
              return;
            }

            //const colors = response.data.
            document.querySelector('#versions-container').innerHTML =
              response.data.html;
            document.dispatchEvent(new CustomEvent('versionsLoaded'));

            attachAllRadioListeners();
            attachModelCardListeners();

            currentStep++;
            updateSteps();

            /*if (modelId) {
                            const radio = document.querySelector(`#versions-container #vm-${modelId}`);
                            radio.click();
                        }*/
          })
          .catch((err) => console.error('Error:', err))
          .finally(hideLoader);
      } else if (currentStep < getSteps().length - 1) {
        // Ultimo paso
        // Cargar datos en los inputs hidden de gforms.
        // modelFieldId y serieFieldId se carga en page-cotiza

        let carIdHidden,
          serieIdHidden,
          yearFieldHidden,
          familyFieldHidden,
          interestFieldModelHidden;
        if (typeof modelFieldId !== 'undefined' && modelFieldId) {
          carIdHidden = document.querySelector(`#${modelFieldId}`);
        }

        if (typeof serieFieldId !== 'undefined' && serieFieldId) {
          serieIdHidden = document.querySelector(`#${serieFieldId}`);
        }

        if (typeof yearFieldId !== 'undefined' && yearFieldId) {
          yearFieldHidden = document.querySelector(`#${yearFieldId}`);
        }

        if (typeof familyFieldId !== 'undefined' && familyFieldId) {
          familyFieldHidden = document.querySelector(`#${familyFieldId}`);
        }

        if (
          typeof interestModelFieldId !== 'undefined' &&
          interestModelFieldId
        ) {
          interestFieldModelHidden = document.querySelector(
            `#${interestModelFieldId}`
          );
        }

        /*if (!carIdHidden || !serieIdHidden) {
                    console.error('Sin campos validos para el ID del modelo ni serie');
                    return;
                }*/

        // Tomar los datos de los checkbox seleccionados para enviarlos a Gravity Forms.
        const selectedModel = document.querySelector(
          '.models input[type="radio"][name="model"]:checked'
        );
        const selectedSerie = document.querySelector(
          '.series input[type="radio"][name="serie"]:checked'
        );

        let modelText, serieText, yearText, familyText, interestModelText;
        if (
          typeof selectedModel !== 'undefined' &&
          selectedModel.dataset.name
        ) {
          modelText = `${selectedModel.dataset.name} (${selectedModel.value})`;
        }

        if (typeof selectedSerie !== 'undefined' && selectedSerie) {
          serieText = `${selectedSerie.dataset.name} (${selectedSerie.value})`;
        }

        if (
          typeof selectedModel !== 'undefined' &&
          selectedModel.dataset.year
        ) {
          yearText = `${selectedModel.dataset.year}`;
        }

        if (
          typeof selectedModel !== 'undefined' &&
          selectedModel.dataset.family
        ) {
          familyText = `${selectedModel.dataset.family}`;
        }

        if (
          typeof selectedModel !== 'undefined' &&
          selectedModel.dataset.interestModel
        ) {
          interestModelText = `${selectedModel.dataset.interestModel}`;
        }

        setOrClearValue(carIdHidden, modelText);
        setOrClearValue(serieIdHidden, serieText);
        setOrClearValue(yearFieldHidden, yearText);
        setOrClearValue(familyFieldHidden, familyText);
        setOrClearValue(interestFieldModelHidden, interestModelText);

        currentStep++;
        updateSteps();
      } else {
        // Enviar datos de gforms
        const form = document.querySelector('form[id^="gform_"]');
        if (!form) return false;

        syncGravityFormInputsBeforeSubmit(form);

        let submitButton = form.querySelector('input[type="submit"]');
        if (!submitButton || submitButton.disabled) return false;

        submitButton.click();
        //form.submit();

        //window.gform.submission.handleButtonClick(submitButton);
      }

      //const step = getStep();
      //console.log(step.dataset);
      /*switch (step.dataset?.section) {
                case 'external-color':
                    btnNext.dispatchEvent(new Event('click'));
                    console.log('exterior-colors-container', step);
                    
                    hasColors = document.querySelectorAll('#exterior-colors-container li');
                    const hasColors = colorItems.length > 0;
                    if (!hasColors) btnNext.dispatchEvent(new Event('click'));

                    break;
                default:
                    console.log('Otra sección')
            }*/

      handleEmptyStepNavigation(getStep(), btnNext);
    });

    btnBack.addEventListener('click', () => {
      if (currentStep > 0) {
        currentStep--;
        updateSteps();

        handleEmptyStepNavigation(getStep(), btnBack);
      }
    });

    // Inicialización
    initializeStateFromUrl();
    attachAllRadioListeners();
    attachModelCardListeners();

    if (urlState.serie) {
      const serieInput = findRadioByValueOrName(
        'input[type="radio"].serie',
        urlState.serie
      );
      const hasModels = !!document.querySelector(
        '.models input[type="radio"][name="model"]'
      );
      const modelExists =
        urlState.model &&
        findRadioByValueOrName(
          '.models input[type="radio"][name="model"]',
          urlState.model
        );

      if (!hasModels || (urlState.model && !modelExists) || urlState.step > 1) {
        loadModelsForSerie(serieInput, urlState.model, urlState.version);
      } else if (urlState.model && modelExists) {
        const modelInput = modelExists;
        modelInput.checked = true;
        modelInput.dispatchEvent(new Event('change', { bubbles: true }));

        if (urlState.version) {
          loadVersionsForModel(modelInput, urlState.version);
        } else {
          setStepFromUrl();
          updateSteps();
        }
      } else {
        setStepFromUrl();
        updateSteps();
      }
    } else {
      setStepFromUrl();
      updateSteps();
    }
  }

  function handleEmptyStepNavigation(step, button) {
    switch (step.dataset?.section) {
      case 'external-color':
        // Verifica si hay ítems de color en el contenedor
        const colorItems = document.querySelectorAll(
          '#exterior-colors-container li'
        );
        const hasColors = colorItems.length > 0;

        // Dispara el botón si no hay colores
        if (!hasColors) {
          document.querySelector('#final-external-color').style.display =
            'none';
          button.dispatchEvent(new Event('click'));
        } else {
          document.querySelector('#final-external-color').style.display =
            'block';
        }

        break;
      case 'interior-color':
        // Verifica si hay ítems de color en el contenedor
        const interiorItems = document.querySelectorAll(
          '#interior-colors-container li'
        );
        const hasInteriors = interiorItems.length > 0;

        // Dispara el botón si no hay colores
        if (!hasInteriors) {
          document.querySelector('#final-interior-color').style.display =
            'none';
          button.dispatchEvent(new Event('click'));
        } else {
          document.querySelector('#final-interior-color').style.display =
            'block';
        }

        break;
      case 'insurance':
        const insuranceInputs = document.querySelectorAll(
          '.step input[type="radio"][name="seguro"]'
        );
        insuranceInputs.forEach((element) => {
          element.dispatchEvent(new Event('change'));
        });

        updateSectionImages();

        break;
      case 'bank':
        const selectedInsurance = getSelectedInsuranceInput();
        sessionStorage.setItem(
          'insurance',
          JSON.stringify(selectedInsurance.dataset)
        );

        const bankContainer = document.querySelector('#bank-container');
        bankContainer
          .querySelectorAll('input[type="text"]')
          .forEach(function (item) {
            item.value += ' ';
            item.value = item.value.trim(); // devuelve al valor original
            item.dispatchEvent(new Event('input', { bubbles: true }));
          });

        document.querySelector('#last-preview').src =
          document.querySelector('.model-image').src;

        break;
      case 'resume':
        updateFinalDataFromSelectedBank();
      default:
        return false;
    }

    return true;
  }

  // En cuota / cotiza, cuando selecciona una versión
  // Cuando carga y renderiza las versiones del Ajax
  document.addEventListener('versionsLoaded', function () {
    const versionsContainer = document.querySelector('#versions-container');
    const versions = versionsContainer.querySelectorAll(
      'input[name="version"]'
    );
    const controlDataBar = document.querySelector('#control-data-bar');

    if (controlDataBar) {
      versions.forEach(function (item) {
        item.addEventListener('change', function (event) {
          updateDataBarOnVersionSelect(event);
          updateTrackingUrl();
        });
        item.dispatchEvent(new Event('change'));
      });
    }
  });

  // En cotiza, cuando selecciona un nuevo modelo
  // Cuando carga y renderiza los modelos del Ajax
  document.addEventListener('modelsLoaded', function () {
    const modelsContainer = document.querySelector('#model-step-container');
    const models = modelsContainer.querySelectorAll('input[name="model"]');
    const controlDataBar = document.querySelector('#control-data-bar');

    if (controlDataBar) {
      models.forEach(function (item) {
        item.addEventListener('change', function (event) {
          updateDataBarOnModelSelect(event);
          updateTrackingUrl();
        });
      });
    }
  });

  function updateDataBarOnModelSelect(e) {
    if (typeof updateTrackingUrl === 'function') {
      updateTrackingUrl();
    }
    const acf = JSON.parse(e.target.dataset.acf);

    const controlDataBar = document.querySelector('#control-data-bar');
    const barFuelType = controlDataBar?.querySelector('#bar-fuel-type');
    const barModelName = controlDataBar?.querySelector('#bar-model-name');
    const barModelPrice = controlDataBar?.querySelector('#bar-model-price');

    const selectedInput = e.currentTarget;

    // Validación + valores por defecto
    const fuelType = selectedInput.dataset.fuelType || 'N/A';
    const modelName = selectedInput.dataset.name || 'N/A';
    const formatedPrice = selectedInput.dataset.formatedPrice || 'N/A';

    // Actualización segura
    if (barFuelType) barFuelType.textContent = fuelType;
    if (barModelName) barModelName.textContent = modelName;
    if (barModelPrice) barModelPrice.textContent = formatedPrice;

    // Ficha técnica
    const technicalDataLink = document.querySelector('#technical-data');
    if (technicalDataLink && acf.ficha.archivo?.url) {
      technicalDataLink.classList.remove('hidden');
      technicalDataLink.href = acf.ficha.archivo.url;
    } else if (technicalDataLink) {
      technicalDataLink.classList.add('hidden');
    }
    //console.log(acf.ficha.archivo.url);
    //console.log(barFuelType, barModelName, barModelPrice);
  }

  function updateDataBarOnVersionSelect(e) {
    if (typeof updateTrackingUrl === 'function') {
      updateTrackingUrl();
    }

    //onsole.log('Version selected');
    const cardLabel = e.target.closest('label');
    const versionImg = cardLabel.querySelector('img');
    if (versionImg) updateSectionImages(versionImg.src);

    const controlDataBar = document.querySelector('#control-data-bar');
    const barModelPrice = controlDataBar?.querySelector('#bar-model-price');

    const selectedInput = e.currentTarget;
    const formatedPrice = selectedInput.dataset.formatedPrice || 'N/A';

    // Actualización segura
    if (barModelPrice) barModelPrice.textContent = formatedPrice;

    //console.log('#e', e.target);
  }

  // Delegar eventos
  document
    .querySelector('#versions-container')
    ?.addEventListener('change', (event) => {
      const dataset = event.target.dataset;
      const acfRaw = dataset?.acf;

      let acf;

      try {
        acf = JSON.parse(acfRaw);
        //console.log('dataset', dataset);
      } catch (e) {
        console.error('Error parsing data-acf:', e, acfRaw);
      }

      const src = event.target.parentElement.querySelector('img').src;
      document.querySelector('.model-image').src = src;

      renderVersionSections.call(event.currentTarget, acf);
    });

  document.addEventListener('gform_pre_submission', function (event, formId) {
    //console.log('Envío inminente (AJAX), formulario ID:', formId);

    // Aquí puedes desactivar tu botón
    const btnNext = document.getElementById('btnNext');
    btnNext.disabled = true;
  });
});

function renderVersionSections(acf) {
  // Todos los pasos con datos que dependen de la versión
  sessionStorage.setItem('acf', JSON.stringify(acf));

  const colors = acf?.colores;
  const interiors = acf?.interiores;
  const insurances = acf?.seguros;
  const banks = acf?.bancos;

  //console.log('acf', acf);

  // colors
  const exteriorColorsContainer = document.querySelector(
    '#exterior-colors-container'
  );
  const colorImage = document.querySelector('#color-image');

  exteriorColorsContainer.innerHTML = '';

  if (colorImage) {
    //console.log('colorImage', colorImage);
    let cImageSrc = getSelectedCarImageSrc();
    colorImage.src = acf?.imagen_color?.url ?? cImageSrc;
  }

  const interiorImage = document.querySelector('#interior-image');
  //console.log('acf?.imagen_interior', acf?.imagen_interior);
  if (interiorImage && acf?.imagen_interior) {
    //console.log('interiorImage', acf.imagen_interior);
    interiorImage.src = acf.imagen_interior.url;
  }

  if (colors) {
    let exteriorColorList = '';
    colors.forEach(function (item) {
      exteriorColorList += `<li class="relative w-full py-[1.6rem] px-[3.4rem]
                text-[1.6rem] text-black font-[400] before:absolute before:left-0 before:!top-0 before:bg-[#00779C] before:!rounded-none
                before:!w-[.4rem] before:!h-full before:opacity-[0] before:invisible hover:before:visible hover:bg-[#F7F7F7] hover:before:opacity-[1]
                duration-[.3s] ease-[ease] before:duration-[.3s] before:ease-[ease] max-[1100px]:text-[0] max-[1100px]:px-[2rem] max-[1100px]:shrink-0 max-[1100px]:w-[12rem]
                max-[1100px]:before:!w-full max-[1100px]:before:!h-[.4rem] max-[1100px]:before:bottom-0 max-[1100px]:before:!top-[initial] max-[1100px]:bg-none
                max-[680px]:w-[9rem]"
                data-img="${item.imagen}">
                    <label class="flex items-center gap-[1.6rem] cursor-pointer max-[1100px]:gap-[0]
                    max-[1100px]:justify-center">
                        <input type="radio" class="hidden peer" name="exterior_color" value="${item.nombre}" data-img="${item.imagen}" data-texture="${item.textura}" data-name="${item.nombre}">
                        <img src="${item.textura}" class="w-[5.1rem] h-[5.1rem] rounded-[50%] border-[.1rem] object-cover border-[#979797]
                        max-[1100px]:w-full max-[1100px]:max-w-[5.1rem]" />
                        ${item.nombre}
                    </label>
                </li>`;
    });

    exteriorColorsContainer.innerHTML = exteriorColorList;
    exteriorColorsContainer.querySelectorAll('li').forEach(function (item) {
      item.addEventListener('click', function (e) {
        //console.log('li', e.target);

        const radio = e.currentTarget.querySelector('input[type="radio"]');
        radio.checked = true;

        // ✅ Usamos el value del input como nombre
        const nameColorElement = document.querySelector('.name-color');
        if (nameColorElement) {
          nameColorElement.textContent = radio.value;
          nameColorElement.style.visibility = 'visible';

          document.querySelector('.model-image').src = radio.dataset?.img;
        }

        radio.dispatchEvent(new Event('change'));
      });
    });
  }

  // Interior
  const interiorColorsContainer = document.querySelector(
    '#interior-colors-container'
  );
  interiorColorsContainer.innerHTML = '';

  if (interiors) {
    let interiorColorList = '';
    interiors.forEach(function (item) {
      interiorColorList += `<li class="relative w-full py-[1.6rem] px-[3.4rem] 
                text-[1.3rem] font-[700] before:absolute before:left-0 before:!top-0 before:bg-[#00779C] before:!rounded-none
                before:!w-[.4rem] before:!h-full before:opacity-[0] before:invisible hover:before:visible hover:bg-[#F7F7F7] hover:before:opacity-[1]
                duration-[.3s] ease-[ease] before:duration-[.3s] before:ease-[ease] max-[1100px]:text-[0] max-[1100px]:px-[2rem] max-[1100px]:shrink-0 max-[1100px]:w-[12rem]
                max-[1100px]:before:!w-full max-[1100px]:before:!h-[.4rem] max-[1100px]:before:bottom-0 max-[1100px]:before:!top-[initial] max-[1100px]:!bg-transparent
                max-[680px]:w-[9rem]"
                data-img="${item.imagen}">
                    <label class="flex items-center gap-[1.6rem] cursor-pointer max-[1100px]:gap-[0]
                    max-[1100px]:justify-center">
                        <input type="radio" class="hidden peer" name="interior_color" value="${item.nombre}" data-img="${item.imagen}" data-texture="${item.textura}" data-name="${item.nombre}">
                        <img src="${item.textura}" class="w-[5.1rem] h-[5.1rem] rounded-[50%] border-[.1rem] border-[#979797]" />
                        ${item.nombre}
                    </label>
                </li>`;
    });

    interiorColorsContainer.innerHTML = interiorColorList;
    interiorColorsContainer.querySelectorAll('li').forEach(function (item) {
      item.addEventListener('click', function (e) {
        const radio = e.currentTarget.querySelector('input[type="radio"]');
        radio.checked = true;

        const nameColorElement2 = document.querySelector('.name-color2');
        if (nameColorElement2) {
          nameColorElement2.textContent = radio.value;
          nameColorElement2.style.visibility = 'visible';
        }

        radio.dispatchEvent(new Event('change'));
      });
    });
  }

  // Seguros
  const insuranceContainer = document.querySelector('#insurance-container');
  insuranceContainer.innerHTML = '';

  /*if (insuranceImage) {
        let cImageSrc = getSelectedCarImageSrc();
        insuranceImage.src = cImageSrc;
    }*/

  if (insurances) {
    let insuranceList = '';
    insurances.forEach(function (item) {
      insuranceList += `<li class="relative w-full max-[1100px]:flex max-[1100px]:max-w-[33.5rem] max-[1100px]:mx-auto">
                    <label class="w-full">
                        <input type="radio" class="hidden peer" name="seguro" value="${item.nombre}" data-name="${item.nombre}" data-price="${item.precio}" data-texture="${item.textura}">
                        <div class="flex items-center gap-[.5rem] py-[1.6rem] px-[3.4rem]
                        text-[1.3rem] font-[700] before:absolute before:left-0 before:!top-0 before:bg-[#00779C] before:!rounded-none
                        before:!w-[.4rem] before:!h-full before:opacity-[0] before:invisible hover:before:visible hover:bg-[#F7F7F7] hover:before:opacity-[1]
                        duration-[.3s] ease-[ease] before:duration-[.3s] before:ease-[ease]
                        peer-checked:before:visible peer-checked:before:opacity-[1] peer-checked:bg-[#F7F7F7]
                        max-[1100px]:flex-col max-[1100px]:justify-center max-[1100px]:items-center max-[1100px]:min-h-[19.7rem]
                        max-[1100px]:border-[.1rem] max-[1100px]:border-[#D7D7D7]
                        max-[1100px]:peer-checked:before:!invisible
                        max-[1100px]:peer-checked:border-[#00779C] max-[1100px]:peer-checked:[&_.mini-check]:flex">  
                            <div class="mini-check w-[2.4rem] h-[2.4rem] rounded-[50%] bg-[#00779C] 
                            hidden items-center justify-center absolute top-0 right-0 translate-x-[1rem]
                            -translate-y-[1rem]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none">
                                    <path d="M4.29114 9L0 4.72216L1.31931 3.40712L4.29114 6.36974L10.6807 0L12 1.31504L4.29114 9Z" fill="white"/>
                                </svg>
                            </div>                          
                            <div class="w-full text-right max-[1100px]:text-center">
                                <h3 class="text-black text-[1.6rem] font-[400]">${item.nombre}</h3>
                                <h4 class="text-[1.2rem] font-[300] text-[#262626]
                                [&_span]:text-[2rem] [&_span]:text-black [&_span]:font-[700] [&_span]:font-mini [&_span]:block
                                [&_span]:text-[#707070] max-[1100px]:[&_span]:text-[#262626]">*Cuota de seguro mensual <span>$${item.precio}</span></h4>
                            </div>
                        </div>
                    </label>
                </li>`;
    });

    insuranceContainer.innerHTML = insuranceList;
    insuranceContainer
      .querySelectorAll('input[type="radio"]')
      .forEach(function (item) {
        item.addEventListener('change', function (e) {
          document.querySelectorAll('.insurance-price').forEach((span) => {
            span.textContent = '$' + item.dataset.price;
          });
        });
      });
  }

  //Banco
  const bankContainer = document.querySelector('#bank-container');
  bankContainer.innerHTML = '';

  let bankList = '';
  banks.forEach(function (item) {
    //console.log('#Test', item, acf);
    const carPrice = acf.precio;
    //const input = item.querySelector(':scope > input[typ="radio"]');

    const rawData = {
      nombre: item.nombre,
      precio_carro: carPrice,
      comision: item.comision,
      cargos_administrativos: item.cargos_administrativos,
      iva: item.iva,
      tasa_de_interes: item.tasa_de_interes,
      plazo_en_meses: item.plazo_en_meses,
      porcentaje_prima: item.porcentaje_prima,
      precio_prima: 0,
      restricciones: item.restricciones,
      seguro: '',
    };

    rawData.precio_prima = (rawData.porcentaje_prima / 100) * carPrice;
    const dataAttr = JSON.stringify(rawData).replace(/"/g, '&quot;');

    bankList += `<div class="col-span-4 bank-card max-[1100px]:col-span-6 max-[680px]:col-span-12" data-bank="${dataAttr}">
                <label class="mt-[2rem]">
                    <input type="radio" class="hidden peer" name="bank" value="${
                      item.nombre
                    }">
                    <div class="relative w-full aspect-[1] border-[.1rem] rounded-[2rem]
                    border-transparent text-[1.4rem] font-[700] bg-white
                    peer-checked:border-[#00779C] peer-checked:[&_.mini-check]:flex
                    peer-checked:text-white cursor-pointer shadow-shadowCard">
                        <div class="mini-check w-[2.4rem] h-[2.4rem] rounded-[50%] bg-[#00779C] 
                        hidden items-center justify-center absolute top-0 right-0 translate-x-[1rem]
                        -translate-y-[1rem]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none">
                                <path d="M4.29114 9L0 4.72216L1.31931 3.40712L4.29114 6.36974L10.6807 0L12 1.31504L4.29114 9Z" fill="white"/>
                            </svg>
                        </div>

                        <div class="px-[3.4rem] pb-[2.8rem] text-[#262626] flex flex-col gap-[1.3rem]
                        max-[1100px]:px-[2rem]">
                            <div class="relative font-[300] mt-[4rem] max-[1100px]:mt-[2rem]">
                                <span class="text-[1.6rem]">Banco</span>
                                <h3 class="text-[2.8rem] text-black">${
                                  item.nombre
                                }</h3>
                            </div>
                            <div class="relative font-[300]" id="car-price">
                                <span class="text-[1.6rem]">Cuota Mensual</span>
                                <h3 class="text-[3.5rem] font-mini font-[700] monthly-fee">-</h3>
                            </div>
                            <div class="relative font-[300] flex flex-col gap-[1rem]">
                                <p class="text-[1.6rem] [&_strong]:font-[700]">
                                    <span>Plazo:</span> <strong class="period-in-month">${
                                      item.plazo_en_meses
                                    } meses </strong>
                                </p>
                                <p class="text-[1.6rem] [&_strong]:font-[700]">
                                    <span>Tasa fija:</span> <strong>${
                                      item.tasa_de_interes
                                    }%</strong>
                                </p>
                                <p class="text-[1.6rem] [&_strong]:font-[700]">
                                    <span>Seguro:</span> <strong class="insurance-price">$-</strong>
                                </p>
                            </div>
                        </div>
                        <div class="text-[#262626] text-center border-t-[.1rem] border-[#C6C6C6] pt-[2rem] 
                        max-[680px]:px-[1.4rem] max-[680px]:pb-[1.9rem]">
                            <span class="text-[1.5rem] font-[300] mb-[.7rem] block">Introduzca el monto de su prima</span>
                            <div class="px-[3.4rem] pb-[2.8rem] flex gap-x-[.6rem] max-[680px]:px-0">
                                <input type="text" class="money-input w-full h-[6rem] text-[2.5rem] text-black font-mini font-[400]
                                placeholder:text-[2.5rem] placeholder:font-mini placeholder:font-[300] placeholder:text-black text-center" 
                                placeholder="$0" data-min="${
                                  rawData.precio_prima
                                }" data-max="${
      rawData.precio_carro
    }" value="${formatCurrency(rawData.precio_prima)}">
                                <div class="show-percentage text-[2rem] text-black
                                w-full max-w-[9.1rem] h-[6rem] font-mini font-[700]
                                flex items-center justify-center bg-[#F2F2F2]">${
                                  item.porcentaje_prima
                                }%</div>
                            </div>

                            <!-- Mensaje de error -->
                            <div class="error-message hidden text-red-500 text-[1.4rem] text-center mb-[.8rem] px-[.5rem] leading-tight">
                                El valor debe estar entre ${formatCurrency(
                                  rawData.precio_prima
                                )} y ${formatCurrency(rawData.precio_carro)}
                            </div>
                        </div>
                    </div>
                    <a href="#" class="select-button w-full bg-black rounded-[10rem] py-[1.5rem] mt-[1.8rem] text-white text-[1.5rem]
                    font-[700] text-center block">
                        Seleccionar esta cuota
                    </a>
                </label>
            </div>`;
  });

  bankContainer.innerHTML = bankList;
  //attachBankEvents();

  bankContainer
    .querySelectorAll('input[type="radio"]')
    .forEach(function (radio) {
      const card = radio.closest('.bank-card');
      if (!card) return;

      const input = card.querySelector('input[type="text"]');
      if (!input) return;

      //console.log('inputs', radio, input);
      const button = card.querySelector('.select-button');

      button.addEventListener('click', function () {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });

      input.dispatchEvent(new Event('input'));
    });

  attachColorListeners();
  attachAllRadioListeners();

  bankContainer.querySelectorAll('input[type="text"]').forEach((input) => {
    const originalValue = input.value;
    const percentageSpan =
      input.parentElement.querySelector('.show-percentage');
    const bankCard = input.closest('.bank-card');

    const radio = bankCard.querySelector('input[type="radio"]');

    const bank = JSON.parse(bankCard.dataset.bank);

    input.value = originalValue + ' '; // Cambio artificial
    input.value = originalValue; // Restaurar

    const errorMessage = bankCard.querySelector('.error-message');

    input.addEventListener('blur', () => {
      let rawValue = input.value.replace(/\D/g, '');

      const min = parseInt(input.dataset.min);
      const max = parseInt(input.dataset.max);
      let numericValue = min; // Valor por defecto en caso de error

      // Resetear estado de error
      input.classList.remove('border-red-500');
      errorMessage.classList.add('hidden');

      // Validación
      if (!rawValue || isNaN(rawValue)) {
        rawValue = 0;
      }

      numericValue = parseInt(rawValue);

      // Verificar límites
      if (numericValue < min || numericValue > max) {
        errorMessage.textContent = `El monto debe estar entre $${new Intl.NumberFormat(
          'es-CL'
        ).format(min)} y $${new Intl.NumberFormat('es-CL').format(max)}`;
        errorMessage.classList.remove('hidden');

        // Ajustar al límite más cercano
        numericValue = Math.max(min, Math.min(numericValue, max));
      }

      // Formatear con símbolo $ y separadores de miles
      input.value = `$${new Intl.NumberFormat('es-CL').format(numericValue)}`;
      percentageSpan.textContent =
        calculatePercentage(bank.precio_carro, numericValue) + '%';

      radio.dataset.premium = numericValue;
    });

    input.addEventListener('input', function (e) {
      errorMessage.classList.add('hidden');

      if (!radio.checked && e.isTrusted) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      let percentage = '-';

      let selectionStart = input.selectionStart;

      // Eliminar todo excepto dígitos
      let rawValue = e.target.value.replace(/\D/g, '');

      // Si no hay nada, limpiar y permitir campo vacío
      if (!rawValue) {
        percentageSpan.textContent = '-';
        radio.dataset.premium = 0;

        // Dejar el campo en blanco cuando el usuario ha borrado todo
        if (e.target.value === '') {
          return;
        }

        // Si sólo hay símbolo u otros caracteres no numéricos, limpiar el campo
        e.target.value = '';
        return;
      }

      percentage = calculatePercentage(bank.precio_carro, rawValue);

      if (percentage >= 0 && percentage <= 100) {
        percentageSpan.textContent = `${percentage}%`;
      } else {
        percentageSpan.textContent = '-';
      }

      // Formatear con separador de miles (puntos)
      let formatted = new Intl.NumberFormat('es-CL').format(
        parseInt(rawValue, 10)
      );
      //console.log('#formatted', formatted);

      e.target.value = `$${formatted}`;

      // Intentar mantener la posición del cursor al escribir
      const diff = e.target.value.length - rawValue.length;
      input.setSelectionRange(selectionStart + diff, selectionStart + diff);

      radio.dataset.premium = rawValue;
    });

    input.dispatchEvent(new Event('input', { bubbles: true }));
    //input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  insuranceContainer
    .querySelectorAll('input[type="radio"]')
    .forEach(function (item) {
      item.addEventListener('change', function (e) {
        //console.log('insurance data', item.dataset);
        bankContainer
          .querySelectorAll('input[type="radio"][name="bank"]')
          .forEach((input) => {
            const card = input.closest('.bank-card');

            //console.log('card', card);

            input.dataset.insurancePrice = item.dataset.price;
            input.dataset.insuranceName = item.dataset.name;
          });
      });
    });
}

function saveStepRadioSelections() {
  sessionStorage.removeItem('multiStepRadioSelections');
  sessionStorage.removeItem('insurance');

  try {
    // Seleccionar radios marcados en todos los steps
    const stepRadios = document.querySelectorAll(
      '.step input[type="radio"]:checked'
    );
    const stepRadioSelections = {};

    // Guardar cada selección usando el name como key
    stepRadios.forEach((radio) => {
      if (radio.name && radio.value) {
        stepRadioSelections[radio.name] = {
          id: radio.value,
          data: radio.dataset,
        };
      }
    });

    stepRadioSelections['acf'] = document.querySelector(
      '#versions-container'
    ).dataset;

    // Guardar en localStorage con nombre descriptivo
    sessionStorage.setItem(
      'multiStepRadioSelections',
      JSON.stringify(stepRadioSelections)
    );

    return stepRadioSelections;
  } catch (error) {
    console.error('Error al guardar selecciones de radios por step:', error);
    return {};
  }
}

function getSelectedCarImageSrc() {
  const colorImage = document.querySelector('#color-image');
  const colorItems = document.querySelectorAll('#exterior-colors-container li');

  const hasColors = colorItems.length > 0;

  if (hasColors) {
    // Si hay colores, todos deben usar colorImage.src si está definido
    if (colorImage && colorImage.src && colorImage.src.trim() !== '') {
      return colorImage.src;
    } else {
      return null; // Hay colores pero no hay imagen válida
    }
  }

  // Si no hay colores, usar la imagen de la versión seleccionada
  const versionContainer = document.querySelector('#versions-container');
  const versionCarInput = versionContainer.querySelector(
    'input[type="radio"]:checked'
  );

  if (!versionCarInput) return null;

  const versionCarLabel = versionCarInput.closest('label');
  const versionCarImage = versionCarLabel.querySelector('img');

  return versionCarImage ? versionCarImage.src : null;
}

function attachColorListeners() {
  const steps = document.querySelectorAll('.step');

  steps.forEach((step) => {
    const colorItems = step.querySelectorAll('.change-color li');
    const carImg = step.querySelector('.color-img');

    colorItems.forEach((item) => {
      item.addEventListener('click', () => {
        colorItems.forEach((el) => el.classList.remove('active-color'));

        item.classList.add('active-color');

        const imageName = item.dataset.img;

        if (carImg) {
          carImg.src = imageName;
        }
      });
    });
  });

  // Detectar cambios en los bancos
  const bankContainer = document.querySelector('#bank-container');
  if (bankContainer) {
    bankContainer.addEventListener('input', function (e) {
      if (e.target.tagName === 'INPUT' && e.target.type === 'text') {
        //console.log(e.target);

        const card = e.target.closest('.bank-card');
        //console.log('card', card);

        if (!card) return;

        const radio = card.querySelector('input[type="radio"]');
        //console.log('radio', radio);

        if (!radio) return;

        // Intenta parsear los datos del banco
        let bank;
        try {
          bank = JSON.parse(card.dataset.bank);
          //console.log('bank', bank);
        } catch (error) {
          console.error('Error al parsear los datos del banco:', error);
          return;
        }

        // Extrae los valores necesarios
        const valor = e.target.value.replace(/[^\d]/g, '');
        const precio = bank.precio_carro;
        const interes = parseLocalizedNumber(bank.tasa_de_interes);
        const plazo = parseLocalizedNumber(bank.plazo_en_meses);
        const seguro = parseLocalizedNumber(radio.dataset.insurancePrice);

        // Calcula la prima (cuotas y valor financiado)
        const prima = calcularCuotaVehiculo(
          valor,
          precio,
          interes,
          plazo,
          seguro
        );
        if (!prima) {
          /*radio.checked = false;
                    radio.dispatchEvent(new Event('change'));*/

          return;
        }

        // Guarda todos los datos como atributos en el radio
        radio.dataset.valorFinanciado = prima.valorFinanciado;
        radio.dataset.cuotaSinSeguro = prima.cuotaSinSeguro;
        radio.dataset.cuotaConSeguro = prima.cuotaConSeguro;
        radio.dataset.bankName = bank.nombre || '';
        radio.dataset.interest = bank.tasa_de_interes;
        radio.dataset.iva = bank.iva;
        radio.dataset.term = bank.plazo_en_meses;
        radio.dataset.commission = bank.comision;
        radio.dataset.restrictions = bank.restricciones || '';

        radio.dataset.premium = valor;

        //console.log('dataset', radio.dataset);

        // Muestra la cuota mensual con seguro en la tarjeta
        const cuotaEl = card.querySelector('.monthly-fee');
        if (cuotaEl) {
          cuotaEl.textContent = '$' + formatCurrency(prima.cuotaConSeguro);
        }
      }
    });
  }
}

function updateSectionImages(customUrl = null) {
  const imageUrl =
    customUrl && customUrl.trim() !== '' ? customUrl : getSelectedCarImageSrc();

  //console.log('updateSectionImages', imageUrl);

  const insuranceImage = document.querySelector('#insurance-image');
  //const interiorImage = document.querySelector('#interior-image');

  /*if (interiorImage) {
        interiorImage.src = imageUrl;
    }*/

  if (insuranceImage) {
    insuranceImage.src = imageUrl;
  }
}

function setOrClearValue(hiddenField, textValue) {
  if (!hiddenField) return; // Si el campo hidden no existe, no hacemos nada

  if (textValue === undefined || textValue === null || textValue === '') {
    hiddenField.value = ''; // Limpiamos si el texto es undefined, null o vacío
  } else {
    hiddenField.value = textValue; // Asignamos el valor si existe
  }
}

function getSelectedInsuranceInput() {
  return document.querySelector(
    '.step input[type="radio"][name="seguro"]:checked'
  );
}

function calcularCuotaVehiculo(
  valorPrimaIngresada,
  precioTotalVehiculo,
  tasaPrestamoAnual,
  plazoMeses,
  valorSeguroMensual
) {
  //console.log('arguments', arguments);

  // --- Parámetros FIJOS del préstamo (estos no cambian) ---
  //const precioTotalVehiculo = 82900; // Valor del vehículo en dólares
  //const tasaPrestamoAnual = 7.75;    // Tasa anual en porcentaje (7.75%)
  //const plazoMeses = 96;             // Plazo del préstamo en meses
  //const valorSeguroMensual = 125;    // Valor del seguro mensual en dólares

  // --- Cálculo del Valor a Financiar (variable según la prima) ---
  const valorAFinanciar = precioTotalVehiculo - valorPrimaIngresada;

  // --- Validación: Asegurarse de que el valor a financiar sea positivo y tenga sentido ---
  if (valorAFinanciar <= 0) {
    console.error(
      'Error: El valor a financiar debe ser mayor que 0. Verifique la prima ingresada.'
    );
    return null; // O podrías lanzar un error, o devolver un objeto con un mensaje de error.
  }
  if (valorAFinanciar > precioTotalVehiculo) {
    console.error(
      'Error: El valor a financiar no puede ser mayor que el precio total del vehículo. Verifique la prima ingresada.'
    );
    return null;
  }

  // --- Cálculo de la Cuota Mensual (misma fórmula de antes) ---

  // Convertir la tasa anual a tasa mensual decimal
  const tasaMensual = tasaPrestamoAnual / 100 / 12;

  // Número total de pagos
  const n = plazoMeses;

  let cuotaSinSeguro;

  // Caso especial para tasa cero (aunque poco probable en préstamos reales)
  if (tasaMensual === 0) {
    cuotaSinSeguro = valorAFinanciar / n;
  } else {
    // Fórmula de amortización francesa
    cuotaSinSeguro =
      (valorAFinanciar * (tasaMensual * Math.pow(1 + tasaMensual, n))) /
      (Math.pow(1 + tasaMensual, n) - 1);
  }

  // Calcular la cuota mensual con seguro
  const cuotaConSeguro = cuotaSinSeguro + valorSeguroMensual;

  // Retornar los resultados
  return {
    valorFinanciado: valorAFinanciar.toFixed(2),
    cuotaSinSeguro: cuotaSinSeguro.toFixed(2),
    cuotaConSeguro: cuotaConSeguro.toFixed(2),
  };
}

function parseLocalizedNumber(value) {
  if (typeof value === 'number') return value;

  if (typeof value === 'string') {
    value = value.trim();
    if (value.includes(',')) {
      // Estilo europeo: "1.234,56"
      value = value.replace(/\./g, '').replace(',', '.');
    }
    // Si no hay coma, se asume que es estilo inglés: "1234.56"
    const parsed = parseFloat(value);
    return isNaN(parsed) ? null : parsed;
  }

  return null;
}

window.fillFinalData = function () {
  const selections = JSON.parse(
    sessionStorage.getItem('multiStepRadioSelections')
  );

  const externalColorItems = document.querySelectorAll(
    '#exterior-colors-container li'
  );
  const hasExternalColors = externalColorItems.length > 0;

  const interiorColorItems = document.querySelectorAll(
    '#interior-colors-container li'
  );
  const hasInteriorColors = interiorColorItems.length > 0;

  //const finalPriceSpan =  document.querySelector('#final-price');
  const finalNameSpan = document.querySelector('#final-vehicle-name');
  const finalTotalPriceSpan = document.querySelector('#final-total-price');

  if (hasExternalColors) {
    const finalExternalColorDiv = document.querySelector(
      '#final-external-color'
    );
    finalExternalColorDiv.querySelector('img').src =
      selections.exterior_color.data.texture;
    finalExternalColorDiv.querySelector('span').textContent =
      selections.exterior_color.data.name;
  }

  if (hasInteriorColors) {
    const finalInteriorColorDiv = document.querySelector(
      '#final-interior-color'
    );
    finalInteriorColorDiv.querySelector('img').src =
      selections.interior_color.data.texture;
    finalInteriorColorDiv.querySelector('span').textContent =
      selections.interior_color.data.name;
  }

  //const externalColorInput = document.querySelector('#final-vehicle-name');
  //const price = document.querySelector('#bar-model-price').textContent;
  const model = document.querySelector('#bar-model-name').textContent;

  //finalPriceSpan.textContent = selections.version.data.formatedPrice;
  finalNameSpan.textContent = selections.version.data.name + ' ' + model;
  finalTotalPriceSpan.textContent = selections.version.data.formatedPrice;
};

window.updateFinalDataFromSelectedBank = function () {
  const selectedRadio = document.querySelector('input[name="bank"]:checked');
  if (!selectedRadio) return;

  const insuranceRadio = document.querySelector('input[name="seguro"]:checked');
  if (!insuranceRadio) return;

  // Obtener valores de los radios seleccionados
  const bankData = {
    financedAmount: parseLocalizedNumber(selectedRadio.dataset.valorFinanciado),
    feeWithoutInsurance: parseLocalizedNumber(
      selectedRadio.dataset.cuotaSinSeguro
    ),
    feeWithInsurance: parseLocalizedNumber(
      selectedRadio.dataset.cuotaConSeguro
    ),
    premium: selectedRadio.dataset.premium,
    insurance: parseLocalizedNumber(insuranceRadio.dataset?.price),
    bankName: selectedRadio.dataset.bankName,
    interest: selectedRadio.dataset.interest,
    term: selectedRadio.dataset.term,
    commission: selectedRadio.dataset.commission,
    restrictions: selectedRadio.dataset.restrictions,
  };

  console.log('bankData', bankData);

  // Actualizar UI
  document.getElementById('value-to-finance').textContent =
    '$' + formatCurrency(bankData.financedAmount);
  document.getElementById('final-premium').textContent =
    '$' + formatCurrency(bankData.premium);
  document.getElementById('without-insurance').textContent =
    '$' + formatCurrency(bankData.feeWithoutInsurance);
  document.getElementById('with-insurance').textContent =
    '$' + formatCurrency(bankData.feeWithInsurance);

  document.getElementById('final-bank-name').textContent =
    bankData.bankName || '';
  document.getElementById(
    'final-interest'
  ).textContent = `${bankData.interest}%`;
  document.getElementById('final-term').textContent = `${bankData.term} meses`;
  document.getElementById(
    'final-comission'
  ).textContent = `Comisión: ${bankData.commission}%`;

  const restrictionEl = document.getElementById('final-restrictions');
  if (restrictionEl) restrictionEl.textContent = bankData.restrictions || '';

  // Obtener selecciones del sessionStorage
  const selections = JSON.parse(
    sessionStorage.getItem('multiStepRadioSelections')
  );
  const model = document.querySelector('#bar-model-name').textContent;

  const selectedModel = document.querySelector(
    '.models input[type="radio"][name="model"]:checked'
  );
  const selectedSerie = document.querySelector(
    'input[type="radio"][name="serie"]:checked'
  );

  // Preparar datos del vehículo
  const vehicleData = {
    brand: 'MINI',
    model: selectedModel.dataset?.name,
    year: selectedModel.dataset?.year,
    serie: selectedSerie.dataset?.name,
    family: selectedModel.dataset?.family,
    version: selections.version?.data?.name,

    fullName: selections.version?.data?.name,
    price: selections.version?.data?.price,
  };

  // Preparar datos de color
  const colorData = {
    exterior: {
      name: selections.exterior_color?.data?.name,
      //code: selections.exterior_color?.data?.code
    },
    interior: {
      name: selections.interior_color?.data?.name,
      //code: selections.interior_color?.data?.code
    },
  };

  // Actualizar UI del vehículo
  document.getElementById('final-vehicle-title').textContent = model;
  document.getElementById('final-vehicle-name').textContent =
    vehicleData.fullName;
  document.getElementById('final-total-price').textContent =
    selections.version?.data?.formatedPrice;

  // Actualizar UI de colores si existen
  const externalColorItems = document.querySelectorAll(
    '#exterior-colors-container li'
  );
  const hasExternalColors = externalColorItems.length > 0;
  const interiorColorItems = document.querySelectorAll(
    '#interior-colors-container li'
  );
  const hasInteriorColors = interiorColorItems.length > 0;

  if (hasExternalColors) {
    const finalExternalColorDiv = document.querySelector(
      '#final-external-color'
    );
    if (finalExternalColorDiv) {
      const img = finalExternalColorDiv.querySelector('img');
      const span = finalExternalColorDiv.querySelector('span');
      if (img) img.src = selections.exterior_color.data.texture;
      if (span) span.textContent = selections.exterior_color.data.name;
    }
  }

  if (hasInteriorColors) {
    const finalInteriorColorDiv = document.querySelector(
      '#final-interior-color'
    );
    if (finalInteriorColorDiv) {
      const img = finalInteriorColorDiv.querySelector('img');
      const span = finalInteriorColorDiv.querySelector('span');
      if (img) img.src = selections.interior_color.data.texture;
      if (span) span.textContent = selections.interior_color.data.name;
    }
  }

  // Llamar a la función para llenar campos hidden
  fillHiddenFormFields(bankData, vehicleData, colorData);

  console.log('bankData', bankData);
};

function calculatePercentage(price, inputValue) {
  if (price === 0) {
    throw new Error('Price cannot be zero');
  }

  const percentage = Math.round((inputValue / price) * 100);
  return percentage;
}

window.fillHiddenFormFields = function (bankData, vehicleData, colorData) {
  //console.log('#DT', bankData, vehicleData, colorData);

  // Mapeo de campos para fácil mantenimiento
  const fieldMap = {
    // Campos de financiamiento
    bankName: 'input_3_32',
    interestRate: 'input_3_33',
    commission: 'input_3_34',
    monthlyPaymentWithoutInsurance: 'input_3_35',
    monthlyPaymentWithInsurance: 'input_3_36',
    premiumAmount: 'input_3_37',
    loanTerm: 'input_3_38',
    insurancePremium: 'input_3_39',

    // Campos del vehículo
    // brand: 'input_3_21',
    serie: 'input_3_15',
    model: 'input_3_14',
    year: 'input_3_22',
    family: 'input_3_20',

    interestModel: 'input_3_23',

    leadSource: 'input_3_25',
    fullVehicleName: 'input_3_26',
    exteriorColorName: 'input_3_27', // Nombre del color exterior
    interiorColorName: 'input_3_28',
    vehiclePrice: 'input_3_29',
    vehicleTotalPrice: 'input_3_30',
    valueToFinance: 'input_3_31',
  };

  // Función helper para asignar valores
  const setFieldValue = (fieldId, value) => {
    const field = document.getElementById(fieldId);
    if (field) field.value = value || '';
  };

  // Llenar datos de financiamiento
  if (bankData) {
    setFieldValue(fieldMap.bankName, bankData.bankName);
    setFieldValue(
      fieldMap.interestRate,
      parseLocalizedNumber(bankData.interest)
    );
    setFieldValue(
      fieldMap.commission,
      parseLocalizedNumber(bankData.commission)
    );
    setFieldValue(
      fieldMap.monthlyPaymentWithoutInsurance,
      parseLocalizedNumber(bankData.feeWithoutInsurance)
    );
    setFieldValue(
      fieldMap.monthlyPaymentWithInsurance,
      parseLocalizedNumber(bankData.feeWithInsurance)
    );
    setFieldValue(fieldMap.financedAmount, bankData.premium.replace('.', ''));
    setFieldValue(fieldMap.loanTerm, parseLocalizedNumber(bankData.term));
    setFieldValue(
      fieldMap.insurancePremium,
      parseLocalizedNumber(bankData.insurance)
    );
    setFieldValue(fieldMap.premiumAmount, bankData.premium.replace('.', ''));
  }

  // Llenar datos del vehículo
  if (vehicleData) {
    setFieldValue(fieldMap.brand, vehicleData.brand || '');
    setFieldValue(fieldMap.serie, vehicleData.serie || '');
    setFieldValue(fieldMap.model, vehicleData.model || '');
    setFieldValue(fieldMap.interestModel, vehicleData.version || '');
    setFieldValue(fieldMap.year, vehicleData.year || '');
    setFieldValue(fieldMap.family, vehicleData.family || '');
    setFieldValue(fieldMap.vehicleCode, vehicleData.code || '');
    setFieldValue(fieldMap.leadSource, 'Cotizador Web');
    setFieldValue(fieldMap.fullVehicleName, vehicleData.fullName || '');
    setFieldValue(
      fieldMap.vehiclePrice,
      parseLocalizedNumber(vehicleData.price)
    );
    setFieldValue(
      fieldMap.vehicleTotalPrice,
      parseLocalizedNumber(vehicleData.price)
    );
    setFieldValue(
      fieldMap.valueToFinance,
      parseLocalizedNumber(bankData.financedAmount)
    );
  }

  // Llenar datos de color
  if (colorData) {
    // Color exterior
    if (colorData.exterior) {
      setFieldValue(fieldMap.exteriorColorName, colorData.exterior.name);
      //setFieldValue(fieldMap.exteriorColorCode, colorData.exterior.code);
    }

    // Color interior - parece que comparte ID con exterior, necesitarías confirmar
    if (colorData.interior) {
      setFieldValue(fieldMap.interiorColorName, colorData.interior.name); // Ajusta según corresponda
    }
  }

  /*const form = document.querySelector('form[id^="gform_"]');
    form.addEventListener('submit', function () {
        const nextButton = document.querySelector('#btnNext');
        nextButton.disabled = true;
    });*/
};

function formatCurrency(value) {
  if (isNaN(value)) return '0';
  return new Intl.NumberFormat('de-DE', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}
